import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';

// 基础薪资分页列表
export const GetUserBaseSalaryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserBaseSalaryPageList", params)
};
// 保存基础薪资信息
export const SaveUserBaseSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/SaveUserBaseSalary", params)
};
// 获取基础薪资详情
export const GetUserBaseSalaryDetail = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserBaseSalaryDetail", params)
};
// 基础薪资调整历史分页列表
export const GetUserBaseSalaryHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserBaseSalaryHistoryPageList", params)
};


// 月度工资分页列表
export const GetUserMonthSalaryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserMonthSalaryPageList", params)
};
// 保存员工月度工资
export const SaveUserMonthSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/SaveUserMonthSalary", params)
};
// 更新员工月工资的基本工资信息
export const UpdateUserMonthBaseSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/UpdateUserMonthBaseSalary", params)
};
// 更新员工月工资的奖金信息
export const UpdateUserMonthBonus = (params) => {
	return reqF("post", "/api/sysConfig/Salary/UpdateUserMonthBonus", params)
};
// 获取员工月度工资详情
export const GetUserMonthSalaryDetail = (params) => {
	return reqF("post", "/api/sysConfig/Salary/GetUserMonthSalaryDetail", params)
};
// 删除员工月度工资
export const DeleteUserMonthSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/DeleteUserMonthSalary", params)
};
// 员工月度工资确认
export const ConfirmUserMonthBaseSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/ConfirmUserMonthBaseSalary", params)
};
// 月度工资导出
export const ExportUserMonthSalary = (params) => {
	return reqF("post", "/api/sysConfig/Salary/ExportUserMonthSalary", params)
};



// 获取提成分页信息
export const GetCommissionPageList = (params) => {
	return reqF("post", "/api/sysConfig/Commission/GetCommissionPageList", params)
};
// 获取员工月发放提成信息
export const GetCommissionEmployeePageList = (params) => {
	return reqF("post", "/api/sysConfig/Commission/GetCommissionEmployeePageList", params)
};
// 获取提成列表信息
export const GetCommissionList = (params) => {
	return reqF("post", "/api/sysConfig/Commission/GetCommissionList", params)
};
// 批量发放提成
export const BatchGrantCommission = (params) => {
	return reqF("post", "/api/sysConfig/Commission/BatchGrantCommission", params)
};
